import { Component, OnInit } from '@angular/core';
import {Constants} from "../constants";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {RulesService} from '../rules.service';

@Component({
  selector: 'app-new-rule',
  templateUrl: './new-rule.component.html',
  styleUrls: ['./new-rule.component.scss']
})
export class NewRuleComponent implements OnInit {
  thing = Constants.THING;
  form: FormGroup;

  constructor(private fb: FormBuilder, private router: Router, private ruleService: RulesService) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({'ruleAppliesTo': [this.thing, [Validators.required]]});
  }

  goToRuleBuilder(formValue) {
     this.ruleService.setRule(null);
     this.ruleService.reSetParentThing();
     this.ruleService.resetActionList();
     this.router.navigate([`rules/${formValue.ruleAppliesTo}/new/step-2`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/new-rule.component.ts